import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import BaseLayoutMixin from '@Framework/layouts/BaseLayoutMixin';
let EmployeeIdeasLayout = class EmployeeIdeasLayout extends BaseLayoutMixin {
};
EmployeeIdeasLayout = __decorate([
    Component({})
], EmployeeIdeasLayout);
export default EmployeeIdeasLayout;
